let language = {
    "MY-ACCOUNT-ALERT-FAIL": "失败",
};

export { language }